import Toggle from '../../utils/Toggle';
import React, { useRef, useState } from 'react';
import ClientCombo from './ClientCombo';

const initialFormData = Object.freeze({
	qb: '',
	nameId: '',
	clientId: '',
	itemName: 'Subscription Fees',
	seatRate: 0,
	thresholdAmount: 0,
	frequency: 0,
	tax: 0,
	taxName: 'No tax',
	message: '',
	lastRunDate: '',
	className: '',
	location: '',
});

const ClientBilling = ({ client }) => {
	const form = useRef(null);
	const [billing, setBilling] = useState(initialFormData);
	const [enabled, setEnabled] = useState(client.billing);

	const handleChange = e => {
		setBilling({
			...billing,

			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});
	};

	return (
		<div className="px-4 space-y-8 divide-y divide-gray-200">
			<div className="pt-8">
				<div>
					<h3 className="text-lg font-medium leading-6 text-gray-900">Billing</h3>
				</div>
				<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
					<div className="sm:col-span-3">
						<Toggle
							label="Enable"
							value={enabled}
							onChangeValue={e => {
								setEnabled(e ? 1 : 0);
							}}
						/>
					</div>
				</div>
				{enabled && (
					<div>
						<form ref={form}>
							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										QuickBooks ID
									</label>
									<input
										required
										name="qbId"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="qb_id"
										onChange={handleChange}
										tabIndex="1"
									/>
								</div>
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										QuickBooks Customer name
									</label>
									<input
										required
										name="nameId"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="qb_client_name"
										placeholder="Client name"
										onChange={handleChange}
										tabIndex="2"
									/>
								</div>
							</div>

							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										QuickBooks Account Name
									</label>
									<input
										required
										name="itemName"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="itemName"
										onChange={handleChange}
										tabIndex="3"
									/>
								</div>
								<div className="sm:col-span-1">
									<ClientCombo client={client} />
								</div>
							</div>

							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Seat Rate
									</label>
									<input
										required
										name="seatRate"
										type="text"
										className="w-24 block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="seatRate"
										onChange={handleChange}
										tabIndex="5"
									/>
								</div>
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Threshold Amount
									</label>
									<input
										required
										name="thresholdAmount"
										type="text"
										className="w-24 block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="thresholdAmount"
										onChange={handleChange}
										tabIndex="6"
									/>
								</div>
							</div>

							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Frequency
									</label>
									<input
										required
										name="frequency"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="frequency"
										onChange={handleChange}
										tabIndex="7"
									/>
								</div>
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Tax Name
									</label>
									<input
										required
										name="taxName"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="frequency"
										onChange={handleChange}
										tabIndex="9"
									/>
								</div>
							</div>

							<div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Location
									</label>
									<input
										required
										name="location"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="location"
										onChange={handleChange}
										tabIndex="10"
									/>
								</div>
								<div className="sm:col-span-1">
									<label
										htmlFor="input_qb_id"
										className="ml-3 block text-sm font-medium text-gray-700">
										Message
									</label>
									<input
										required
										name="message"
										type="text"
										className="block w-full min-w-0 flex-1 rounded-none rounded-l-md rounded-r-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm invalid:border-red-500"
										id="message"
										onChange={handleChange}
										tabIndex="11"
									/>
								</div>
							</div>
						</form>
					</div>
				)}
			</div>
		</div>
	);
};

export default ClientBilling;
